import React, { Component } from 'react';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import {
    WithStyles,
    createStyles,
    Button,
    MenuItem,
    Popover,
    MenuList,
    Link,
    Grid,
    Typography,
    Chip
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ContentFormData from '../../types/ContentFormData';
// import { MenuData } from '../../common';
// import CustomInfoIcon from '../../common/CustomInfoIcon';
const styles = createStyles({
    // variation card
    grayCard:{
        background: '#EFEEEE',
        borderRadius: '4px 4px 0px 0px',
        boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.287534)',
        padding: '12px 20px',
        marginBottom: '-12px'
    },
    quesHeading:{
        fontSize: '20px',
        lineHeight: '32px',
        color: '#333',
        marginBottom: '8px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        width: '60%',
        display: 'inline-block',
        '&>:first-child':{
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            width: '100%',
            display: 'inline-block',
            margin: 0,
            '&>span':{
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                width: '100%',
                display: 'inline-block',
            }
        },
    },
    truncateTxt:{
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        width: '100px',
        fontFamily: "'Nunito', san-serif",  
    },
    classIcon:{
        fontFamily: "'Nunito', san-serif",  
        '& img':{
            margin: '0 8px 0 14px',
            verticalAlign: 'middle',
        }
    },
    classTxt:{
        fontSize: '14px',
        fontFamily: "'Nunito', san-serif",  
        verticalAlign: 'middle',
        '&>span':{
            color: '#666',
        }
    },
    createdBy:{
        fontSize: '14px',
        fontWeight: 600,
        color: '#999'
    },
    createdByName:{
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        width: '125px',
        fontSize: '14px',
        fontWeight: 600,
        color: '#666',
        display: 'inline-block',
        verticalAlign: 'middle'
    }
});

interface VarientQuestionCardProps extends WithStyles<typeof styles> {
    title?: string,
    content: any,
    from?: string
}
interface VarientQuestionCardState {
    isHelpList: boolean,
    setAnchorEl: any,
    anchorEl: any,
    showTooltip: boolean,
    showDropdown: boolean
}

class VarientQuestionCard extends Component<VarientQuestionCardProps, VarientQuestionCardState>{    

    constructor(props: VarientQuestionCardProps, state: VarientQuestionCardState) {
        super();
        let self = this;
        self.state = {
            isHelpList: false,
            anchorEl: null,
            setAnchorEl: null,
            showTooltip: false,
            showDropdown: false
        }
    }

    mouseHoverHandle = () => {
        this.setState({
            showTooltip: !this.state.showTooltip
        })
    }
    handleVarientQuestionCard = () =>{
        this.setState({
            showDropdown: !this.state.showDropdown
        })
    }

    handleTitle = (title: any) => {
        
        let firstLine = title.split('</p>')[0];
        firstLine = firstLine.substring(3);
        return firstLine;
    }

    render() {
        let self = this;
        const { classes, title, content } = this.props;
        const { anchorEl, showTooltip, showDropdown } = this.state;
        
        return (
            <>
                <Grid className={classes.grayCard}>
                    <Typography className={classes.quesHeading} 
                    dangerouslySetInnerHTML={{ __html: 
                        title ? this.handleTitle(title) :
                        this.handleTitle(content.masterVariationQuestionData.content[0].questionContent) }}>
                    </Typography>
                    <Grid container justify="space-between" alignItems="center">
                        <Grid>
                            <Chip
                                label="Master Question"
                                color="primary"
                            />
                            <span className={classes.classIcon}>
                                <img src="/assets/svg/myLibrary/quesIcon.svg"/>
                                    <span className={classes.classTxt}>

                                    {_.get(content, 'subjects[0].subSubjects[0].chapters[0].concepts[0].classId.name', '')} {' / '}
                                    {_.get(content, 'subjects[0].subjectId.name', '')}
                                    </span>
                            </span> 
                        </Grid>  
                        <Typography className={classes.createdBy}>
                                Created by: <span className={classes.createdByName}>
                                    {_.get(content, 'aclMetaData.createdBy.id.fullName', '')}</span>
                        </Typography>
                    </Grid>
                </Grid>
            </>
        );
    }
}

// @ts-ignore
export default withStyles(styles)(VarientQuestionCard);